import { render, staticRenderFns } from "./ModalCreationCommande.vue?vue&type=template&id=5ac746b2&"
import script from "./ModalCreationCommande.vue?vue&type=script&lang=js&"
export * from "./ModalCreationCommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports